"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowALeftIcon24Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowALeftIcon24Solid = forwardRef_1.forwardRef('ArrowALeftIcon24Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M10.998 18.814a1.5 1.5 0 1 1-2.121 2.122l-6.284-6.284a3.75 3.75 0 0 1 0-5.304l6.284-6.284a1.5 1.5 0 1 1 2.121 2.122L5.684 10.5H21a1.5 1.5 0 1 1 0 3H5.684l5.314 5.314Z" })));
});
